import React, { useState, useEffect } from 'react';
import { get_securities_fees } from '../../services/common';
import moment from 'moment';

const SecuritiesFees = ({ fumId }) => {
  const [fees, setFees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (fumId) {
      getSecuritiesFees();
    }
  }, [fumId]);

  const getSecuritiesFees = async () => {
    try {
      // const localData = JSON.parse(localStorage.getItem('caprock-local') || '{}'); // Fixed: Changed variable name
      // const userToken = localData['access-token']; // Fixed: Updated reference
      const userToken = localStorage.getItem('systemToken') || "";
      const response = await get_securities_fees(userToken, fumId);
      
      if (response.success === 200) {
        const feesData = response.fees || [];
        let lastDate = '';
        
        const processedFees = feesData.map(fee => {
          const feeDate = moment(fee.fee_date).format('DD MMM, YYYY');
          const isNewDate = feeDate !== lastDate;
          lastDate = feeDate;
          
          return {
            ...fee,
            fee_date: feeDate,
            is_new_date: isNewDate,
            fee_amount: typeof fee.fee_amount !== 'undefined' 
              ? fee.fee_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '0.00'
          };
        });

        setFees(processedFees);
      } else {
        setFees([]);
      }
    } catch (error) {
      console.error('Error fetching securities fees:', error);
      setFees([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-1 py-3 border-b">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  if (!fumId) {
    return null;
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <div className="w-full mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Month End Dates</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Details</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fees Type</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Inc GST</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paid</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Balance</th>
              </tr>
            </thead>
            <tbody>
              {fees.length > 0 ? (
                fees.map((fee) => (
                  <tr 
                    key={fee.fee_id} 
                    className={`hover:bg-gray-50 ${fee.fee_border === 1 ? 'border-t-4 border-gray-400' : ''}`}
                  >
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.fee_date}
                    </td>
                    <td 
                      className="border border-gray-300 px-2 py-1 text-sm" 
                      style={{ maxWidth: '250px', whiteSpace: 'break-spaces' }}
                    >
                      {fee.fee_details}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {fee.fee_type === 1 ? 'Acquisition Fee' : 'FUM Cash A/C Fee'}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof fee.fee_amount !== 'undefined' 
                        ? `${fee.currency_symbol} ${fee.fee_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof fee.fee_inc_gst_amount !== 'undefined' 
                        ? `${fee.currency_symbol} ${fee.fee_inc_gst_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof fee.fee_paid_amount !== 'undefined' 
                        ? `${fee.currency_symbol} ${fee.fee_paid_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof fee.fee_balance !== 'undefined' 
                        ? `${fee.currency_symbol} ${fee.fee_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SecuritiesFees;
